import { CollapsibleSection } from "components/collapsibleSection"
import { IOrderDetail } from "interfaces"

export const VATSection = ({orderDetailData} : {orderDetailData: IOrderDetail | null}) => {
  return (
    <CollapsibleSection 
      label="VAT Information"
      defaultOpen={false}
    >
      <div className="grid gap-x-4 gap-y-6 px-4 py-4 text-sm sm:px-6 grid-cols-12 lg:gap-x-6" style={{wordBreak: "break-word"}}>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-1">
          <div className="col-span-2">
            <p className="font-medium">
              Company name
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {orderDetailData?.tax?.company_name}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-3">
          <div className="col-span-2">
            <p className="font-medium">
              Company address
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {orderDetailData?.tax?.company_address}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-5">
          <div className="col-span-2">
            <p className="font-medium">
              Company tax code
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {orderDetailData?.tax?.company_tax_code}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-2">
          <div className="col-span-2">
            <p className="font-medium">
              Recipient's name
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {orderDetailData?.tax?.recipient_name}
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-4">
          <div className="col-span-2">
            <p className="font-medium">
              Recipient's phone
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {orderDetailData?.tax?.recipient_phone 
                ? `${orderDetailData.tax.recipient_phone_area_code ? `(+${orderDetailData.tax.recipient_phone_area_code})` : ""} ${orderDetailData?.tax.recipient_phone}` 
                : ""
              }
            </p>
          </div>
        </div>
        <div className="grid gap-x-4 grid-cols-6 gap-y-6 col-span-full sm:col-span-6 sm:order-6">
          <div className="col-span-2">
            <p className="font-medium">
              Email
            </p>
          </div>
          <div className="col-span-4">
            <p>
              {orderDetailData?.tax?.recipient_address}
            </p>
          </div>
        </div>
      </div>
    </CollapsibleSection>
  )
}